module.exports = __webpack_public_path__ + "static/media/card_2x.bf8af0d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/sacramento/card_2x.jpg
// module id = 940
// module chunks = 27